import api from "../../../Api/feathers-client";

export const getDataService = async (servicename, params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service(servicename).find(params);
      resolve({
        status: 200,
        message: "Assignment progressive summary log data",
        data: response,
      });
    } catch (error) {
      resolve("error", error);
    }
  });
};
